import { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { Breadcrumbs, Typography } from '1_shared/ui';

import { RoutePath } from '../../../1_shared/config/routes';

import { ISpecialistEntitiesCardProps } from './interfaces/ISpecialistEntitiesCardProps';

import styles from './SpecialistPersonCardData.module.scss';
import SpecialistReserveSlotMobile from '../../../3_features/SpecialistReserveSlot/ui/SpecialistReserveSlotMobile';
import SpecialisationInfo from '../../../3_features/SpecialisationInfo/ui/SpecialisationInfo';

const breadCrumbs = [
  {
    title: (
      <Link to={RoutePath.MAIN}>
        <Typography type="description">DOTHERAPY</Typography>
      </Link>
    ),
  },
  {
    title: (
      <Link to={RoutePath.SPECIALISTS}>
        <Typography type="description">Специалисты</Typography>
      </Link>
    ),
  },
];

const SpecialistPersonCardDataMobile = ({
  specialist,
  onChange,
  pageType,
}: ISpecialistEntitiesCardProps): ReactElement => (
  <div className={styles.root}>
    <div className={styles.nameAndSpec}>
      <div className={styles.specialistPersonInfo}>
        <div className={styles.nameBlock}>
          <Breadcrumbs items={breadCrumbs} />
          <Typography className={styles.firstName} type="title">
            {specialist.firstName}
          </Typography>
          <Typography className={styles.secondName} type="title">
            {specialist.secondName}
          </Typography>
          <SpecialisationInfo specialist={specialist} />
        </div>
        <SpecialistReserveSlotMobile
          specialistId={specialist.id}
          spec={specialist}
          pageType={pageType}
          onChange={onChange}
        />
      </div>
    </div>
  </div>
);

export default SpecialistPersonCardDataMobile;
